import type {
  ArchiveRecord,
  BehaviorEvent,
  ChannelName,
  GenerationAdapter,
  GenerationChannel,
  VisitSnapshot,
} from '../shared/types'
import { getExhibit } from '../content/exhibits'

const wait = (ms: number, signal?: AbortSignal) => new Promise<void>((resolve, reject) => {
  if (signal?.aborted) return reject(new DOMException('Generation cancelled', 'AbortError'))
  const timeout = setTimeout(resolve, ms)
  signal?.addEventListener('abort', () => {
    clearTimeout(timeout)
    reject(new DOMException('Generation cancelled', 'AbortError'))
  }, { once: true })
})

function summarizeEvent(event: BehaviorEvent): string {
  const exhibit = getExhibit(event.exhibitId)
  const actionLabel: Record<BehaviorEvent['action'], string> = {
    browse: '浏览', play: '播放', agree: '赞同', oppose: '保留意见', ignore: '略过',
    comment: '回应', share: '转发', grow: '推荐', report: '标记',
  }
  return `${event.sequence}. ${exhibit?.title ?? event.exhibitId} · ${actionLabel[event.action]}（${Math.round(event.elapsedMs / 1000)} 秒）`
}

export const mockGenerationAdapter: GenerationAdapter = {
  provider: 'mock',
  async generate(snapshot, channel, signal) {
    await wait(channel === 'text' ? 180 : 320, signal)
    if (channel === 'image') return '/assets/unity/art-14.png'
    const entries = snapshot.events.length
      ? snapshot.events.map(summarizeEvent).join('\n')
      : '这次参观没有留下互动记录。'
    return `本地参观摘要\n${snapshot.visitorLabel} 在馆内留下 ${snapshot.events.length} 条记录。\n\n${entries}\n\n这是本地演示摘要，不是 AI 分析。`
  },
}

export function localSummary(snapshot: VisitSnapshot): string {
  if (snapshot.events.length === 0) return '本次没有记录到有效互动。\n参观档案已封存。'
  return `本地参观摘要 · ${snapshot.events.length} 条记录\n\n${snapshot.events.map(summarizeEvent).join('\n')}`
}

export function emptyGenerationChannel(): GenerationChannel {
  return { status: 'idle', attempt: 0 }
}

export function isCurrentAttempt(archive: ArchiveRecord | undefined, channel: ChannelName, attempt: number): boolean {
  return Boolean(archive && archive[channel].attempt === attempt)
}
